import React from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';

const Logo = () => {
  const theme = ApiLocalStorage.get('theme') || {};

  const logo = theme?.login?.logo;

  if (logo) {
    return (
      <img 
        style={{ maxHeight: '100%', margin:'0 auto', height: theme?.designTokens?.['logotipo-height'] }} 
        src={theme?.login?.logo} 
        alt="Logo"
      />
    );
  }

  return <></>;
};

export default Logo;
